// extracted by mini-css-extract-plugin
module.exports = {"discountSignal":"DiscountSignal_discountSignal__7cZkQ"};